import { Link } from "react-router-dom";

import { ROUTES } from "~/router/constants";
import { BOOK_VISIT } from "~/screens/Hub/shared/sharedUrls";
import { Button } from "~/shared";
import { useUsers } from "~/shared/hooks/useUsers";
import { customIcons } from "~/ui";
import { tw } from "~/utils";
import { UpcomingVisitItem } from "./UpcomingVisitItem";
import { VisitCancellationPolicy } from "./VisitCancellationPolicy";

interface UpcomingVisitsCardProps {
  className?: string;
}

const EmptyState = () => (
  <div className="flex w-full flex-col items-center gap-5">
    <div className="border-blueGrey flex w-full flex-col items-center gap-2 rounded-lg border-2 border-dashed p-6 md:gap-5 md:p-10">
      <p className="text-midnight-indigo text-base italic">
        No upcoming visits
      </p>
      <Button className="px-12 py-3" asChild>
        <Link to={ROUTES.hubBookVisit}>Book a visit</Link>
      </Button>
    </div>
    <div className="flex flex-col items-center gap-2 text-center">
      <p className="text-midnight-indigo text-sm md:text-base">
        Billed to you or your insurance.
      </p>
      <a
        href={BOOK_VISIT}
        target="_blank"
        rel="noopener noreferrer"
        className="text-violet inline-flex items-center gap-1 font-sans text-sm font-medium hover:underline md:text-base"
      >
        Find out if you&apos;re covered
        <customIcons.ArrowRight className="text-violet inline size-5" />
      </a>
    </div>
  </div>
);

export const UpcomingVisitsCard = ({ className }: UpcomingVisitsCardProps) => {
  const { getUserAppointments } = useUsers();
  const { data: visits, isLoading } = getUserAppointments(true);

  return (
    <div className={tw("flex flex-col gap-4", className)}>
      {isLoading ? (
        <div className="flex justify-center py-8">
          <customIcons.SpinnerIcon className="text-indigo size-8 animate-spin" />
        </div>
      ) : !visits || visits.length === 0 ? (
        <EmptyState />
      ) : (
        <>
          {visits.map((visit) => (
            <UpcomingVisitItem key={visit.id} visit={visit} />
          ))}
          <VisitCancellationPolicy />
        </>
      )}
    </div>
  );
};
